import { ProfileBlockApi } from 'api/ApiHelper';
import { profileBlockQueryKey } from 'queries/profileBlock/queryKey';
import { useQuery } from '@tanstack/react-query';

export const useGetBlockProfilesQuery = (enabled = false) =>
  useQuery({
    queryKey: profileBlockQueryKey.profileBlocks,
    queryFn: () => ProfileBlockApi.findAllBlockProfile(),
    enabled,
  });
